import { createReducer } from "@reduxjs/toolkit";
import { getAuthenticationSession } from "../actions/authentication";
import type { AuthenticationState } from "../types/Authentication";
import { resolveRsaaErrorMessage } from "../utils/rsaaErrorMessage";

const initialState: AuthenticationState = { status: "idle" };

export const authentication = createReducer(initialState, (builder) => {
    builder.addCase(getAuthenticationSession.request, (state) => {
        state.status = "checking";
        state.error = undefined;
    });
    builder.addCase(getAuthenticationSession.success, (state, action) => {
        state.session = action.payload;
        state.status = action.payload.authenticated
            ? "authenticated"
            : "unauthenticated";
        state.error = undefined;
    });
    builder.addCase(getAuthenticationSession.error, (state, action) => {
        state.status = "error";
        state.error = resolveRsaaErrorMessage(
            action.payload,
            "Unable to determine available authentication methods."
        );
    });
});
